document.addEventListener('DOMContentLoaded', function() {
  const headers = document.querySelectorAll('h2');
  if (headers.length === 0) return;

  const navContainer = document.createElement('div');
  navContainer.id = 'article-nav';
  document.body.insertBefore(navContainer, document.body.firstChild);

  const navList = document.createElement('ul');
  navList.className = 'nav-list';

  headers.forEach((header, index) => {
    if (!header.id) header.id = `section-${index}`;
    
    const listItem = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${header.id}`;
    link.textContent = header.textContent;
    link.className = 'nav-link';
    
    link.addEventListener('click', smoothScroll );
    listItem.appendChild(link);
    navList.appendChild(listItem);
  });

  navContainer.innerHTML = '<div class="title">Оглавление</div>';
  navContainer.appendChild(navList);
  const blogNav = document.querySelector('.blog-plan');
  blogNav.appendChild(navContainer);



  // Используем Intersection Observer для подсветки активного раздела
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const id = entry.target.id;
      const link = document.querySelector(`.nav-list a[href="#${id}"]`);
      if (link) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      }
    });
  }, { threshold: 0.5 });

  headers.forEach(header => observer.observe(header));
});

function smoothScroll(e) {
  e.preventDefault();
  e.stopPropagation(); // Добавьте эту строку
  const targetId = this.getAttribute('href');
  const target = document.querySelector(targetId);
  window.scrollTo({
    top: target.offsetTop,
    behavior: 'smooth'
  });
}